// "Corregir" desde Calidad de datos (6/10/2026): la ficha o el formulario
// reciben en ?volver= la direccion de la revision para regresar a ella. Solo
// se aceptan direcciones de la misma app (empiezan con "/" y no con "//"),
// para que un enlace no pueda llevar a otro sitio.
export function direccionDeVuelta(parametros: URLSearchParams): string | null {
  const volver = parametros.get('volver');
  return volver && volver.startsWith('/') && !volver.startsWith('//') ? volver : null;
}

export type TipoDeCaso = 'bolsa' | 'exportacion';

// Big Bag o exportacion de un caso de calidad, a partir de su enlace.
export function casoDeEnlace(enlace: string | null): {tipo: TipoDeCaso; clave: string} | null {
  const m = /^\/(inventario|seguimiento)\/([^/?#]+)$/.exec(enlace ?? '');
  return m ? {tipo: m[1] === 'inventario' ? 'bolsa' : 'exportacion', clave: decodeURIComponent(m[2]!)} : null;
}

// Direccion para corregir un registro y volver a `vuelta`: la ficha del Big
// Bag abierta en edicion o el formulario de la exportacion. null si el enlace
// no es de un Big Bag ni de una exportacion.
export function direccionParaCorregir(enlace: string, vuelta: string): string | null {
  const volver = `volver=${encodeURIComponent(vuelta)}`;
  if (/^\/inventario\/[^/?#]+$/.test(enlace)) return `${enlace}?editar=1&${volver}`;
  if (/^\/seguimiento\/[^/?#]+$/.test(enlace)) return `${enlace}/editar?${volver}`;
  return null;
}
